/* src/app/shared/components/image-zoom/image-zoom.component.css */
.imgToZoom {
  width: 100%;
  cursor: pointer;
}
.imgToZoom:hover {
  box-shadow: 0 0 6px 3px rgba(0, 12, 186, 0.5);
}
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(0 0 0 / 68%);
  z-index: 2;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  opacity: 0;
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  pointer-events: none;
}
.lightbox.active {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
  pointer-events: auto;
}
.lightbox .imgZoom {
  max-width: 80%;
  max-height: 80vh;
  background: #fff;
  color: rgba(0, 0, 0, 0.87);
  -o-object-fit: cover;
  object-fit: cover;
}
/*# sourceMappingURL=image-zoom.component.css.map */
